/**
 * Our API IntegerField model requires that the value be an integer or null.
 * Passing a string will cause a 400 validation error.
 *
 * @param {*} int
 */
export const validateInteger = int => (Number.isInteger(int) ? int : null)
